export default __webpack_public_path__ + "static/media/bg-pattern-mobile-nav.b2fceba3.svg";